import { OndigoNS } from '../modules/main.js';

(function ($) {
    'use strict';

    // class definition
    OndigoNS.TabNavigation = function (element) {
        this.$tabNavigation = $(element);
        this.$tabs = this.$tabNavigation.find('>h3');
        this.$tabContents = this.$tabNavigation.find('.tabContent');
        this.isWideNavigation = this.$tabNavigation.hasClass('wideNavigation');
        this.$window = $(window);
        this.init();
    };

    OndigoNS.TabNavigation.prototype = {
        init: function () {
            var _instance = this;

            if(this.$tabNavigation.hasClass('displayAsAccordionOnTablet')) {
                this.displayTabsAsToggler();
            } else {
                this.$tabNavigation.find('.tab1').addClass('active');
                this.setMenuPositions();
            }

            if (this.isWideNavigation) {
                this.updateWideNavigation();
            }

            this.$tabs.on('click', function (e) {
                var resizeState = OndigoNS.Utils.getCurrentState();
                if(_instance.$tabNavigation.hasClass('displayAsAccordionOnTablet') && resizeState === OndigoNS.TabletState) {
                    _instance.accordeonAnimation(e);
                } else {
                    _instance.hideAndShow(e);
                }
            });

            if (OndigoNS.Utils.hasTouchscreen()) {
                this.$window.on('orientationchange', function () {
                    setTimeout(function () {
                        if (_instance.isWideNavigation) {
                            _instance.updateWideNavigation();
                        }
                        if(_instance.$tabNavigation.hasClass('displayAsAccordionOnTablet')) {
                            _instance.displayTabsAsToggler();
                        }
                        _instance.updateTabHeight();
                        _instance.setTabcontentMinHeightOnTablet();
                    }, 300);
                });
            }
            else {
                this.$window.on('resize', function () {
                    if (_instance.isWideNavigation) {
                        _instance.updateWideNavigation();
                    }
                    if(_instance.$tabNavigation.hasClass('displayAsAccordionOnTablet')) {
                        _instance.displayTabsAsToggler();
                    }
                    _instance.updateTabHeight();
                    _instance.setTabcontentMinHeightOnTablet();
                });
            }

            this.$window.on('load', function () {
                if(_instance.$tabNavigation.hasClass('displayAsAccordionOnTablet')) {
                    _instance.displayTabsAsToggler();
                }
                _instance.updateTabHeight();
                _instance.setTabcontentMinHeightOnTablet();
                _instance.showAnchorTabContent();
            });
        },
        hideAndShow: function (e) {
            this.$tabNavigation.find('.active').removeClass('active');
            var $activeTab = this.$tabNavigation.find('.tab' + (parseInt(this.$tabs.index($(e.target)), 10) + 1)).addClass('active');
        },
        setMenuPositions: function () {
            var x = 0,
                y = 0;
            if(this.$tabNavigation.parents('.phasesOfSale').length && OndigoNS.Utils.getWindowInnerWidth() >= OndigoNS.breakpointWide && OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointMax) {
                $.each(this.$tabs, function () {
                    $(this).css('left', '0');
                    $(this).css('top', y);
                    y = y + $(this).outerHeight() + 2;
                });
            } else {
                $.each(this.$tabs, function () {
                    $(this).css('left', x);
                    $(this).css('top', '0');
                    x = x + $(this).innerWidth() + 2;
                });
            }
        },
        updateWideNavigation: function () {
            var tabLength = this.$tabs.length,
                tabWidth = parseInt(this.$tabNavigation.width(), 10) / tabLength,
                x = 0,
                _instance = this,
                resizeState = OndigoNS.Utils.getCurrentState();

            $.each(this.$tabs, function (index) {
                if(_instance.$tabNavigation.hasClass('displayAsAccordionOnTablet') && resizeState === OndigoNS.TabletState) {
                    $(this).css({
                        width : 'auto',
                        left : 0
                    });
                } else if(_instance.$tabNavigation.parents('.phasesOfSale').length && OndigoNS.Utils.getWindowInnerWidth() >= OndigoNS.breakpointWide && OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointMax) {
                    $(this).css({
                        width : '192px',
                        left : 0
                    });
                } else {
                    // prevent small gap at the end
                    let spacer = index === tabLength - 1 ? 0 : 2;
                    $(this).css({
                        width : tabWidth - spacer,
                        left : x
                    });
                }

                x = x + ($(this).innerWidth() + 2);
            });
        },
        updateTabHeight: function () {
            var maxHeight = 0,
                topMargin,
                resizeState = OndigoNS.Utils.getCurrentState();

            this.$tabs.css('height', '');

            $.each(this.$tabs, function () {
                maxHeight = Math.max(parseInt($(this).innerHeight(), 10), maxHeight);
            });

            this.$tabs.css('height', maxHeight.toFixed(2));

            if(this.$tabNavigation.hasClass('displayAsAccordionOnTablet') && resizeState === OndigoNS.TabletState || (this.$tabNavigation.parents('.phasesOfSale').length && OndigoNS.Utils.getWindowInnerWidth() >= OndigoNS.breakpointWide && OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointMax)) {
                topMargin = 0;
                this.$tabs.css('height', '');
            } else {
                topMargin = (parseInt(this.$tabs.height(), 10) + parseInt(this.$tabs.css('padding-top'), 10) * 2) + 2;
            }
            this.$tabContents.css('margin-top', topMargin.toString() + 'px');

        },
        displayTabsAsToggler : function () {
            var resizeState = OndigoNS.Utils.getCurrentState();

            if(resizeState === OndigoNS.TabletState) {
                this.$tabs.removeClass('active');
                this.$tabContents.removeClass('active').css('display', 'none');
                this.$tabContents.css('margin-top', '10px');
                this.$tabs.css('height', 'auto');
                $.each(this.$tabs, function () {
                    $(this).css('left', '0');
                    $(this).css('top', '0');
                });
            } else {
                this.$tabs.removeClass('active');
                this.$tabContents.removeClass('active');
                this.$tabNavigation.find('.tab1').addClass('active');
                this.$tabContents.css('height', '');
                this.updateTabHeight();
                this.setMenuPositions();
            }
        },
        accordeonAnimation : function (e) {
            var $currentAccordion = $(e.target),
                $openedAccordion = this.$tabNavigation.find('.active');
            if (!$currentAccordion.hasClass('active')) {
                $currentAccordion.addClass('active');
                this.$tabNavigation.find('.tabContent.tab' + (parseInt(this.$tabs.index($(e.target)), 10) + 1)).slideDown().addClass('active');
            }

            if($openedAccordion.length) {
                $openedAccordion.eq(0).removeClass('active');
                $openedAccordion.eq(1).slideUp();
                $openedAccordion.eq(1).removeClass('active');
                $openedAccordion.eq(0).removeClass('active');
            }
        },
        setTabcontentMinHeightOnTablet : function () {
            if (this.$tabNavigation.parents('.phasesOfSale').length && OndigoNS.Utils.getWindowInnerWidth() >= OndigoNS.breakpointWide && OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointMax) {
                var height = this.$tabs.outerHeight(),
                    count = this.$tabs.length;
                this.$tabContents.css('min-height', (height * count) + 20 + 'px');
            } else {
                this.$tabContents.css('min-height', '0');
            }
        },
        showAnchorTabContent : function () {
            var hash = window.location.hash;

            if($(hash).length) {
                if($(hash).parents('.tabNavigation .tabContent').length) {
                    this.$tabs.removeClass('active');
                    this.$tabContents.removeClass('active');
                    $(hash).parents('.tabNavigation .tabContent').prev().addClass('active');
                    if(this.$tabNavigation.parents('.phasesOfSale').length && OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointWide) {
                        $(hash).parents('.tabNavigation .tabContent').slideDown().addClass('active');
                    } else {
                        $(hash).parents('.tabNavigation .tabContent').addClass('active');
                    }
                }
            }
        }
    };
    // plugin definition
    $.fn.tabNavigation = function () {
        return new OndigoNS.TabNavigation(this);
    };
    $.fn.tabNavigation.Constructor = OndigoNS.TabNavigation;

}(window.jQuery));

$(document).ready(function () {
    'use strict';

    var $tabNavigation = $('.tabNavigation');
    if ($tabNavigation.length) {
        $.each($tabNavigation, function () {
            $(this).tabNavigation();
        });
    }
});